import { api } from "./api";

export const professorsList = async (params: {
  search?: string;
}): Promise<any> => {
  const { data } = await api.get("professor", { params });
  return data;
};

export const professorsIndicators = async (params: {
  startDate: Date;
  endDate: Date;
}): Promise<any> => {
  const { data } = await api.get("professor/indicators", { params });
  return data;
};

export const professorsListById = async (id: string | number): Promise<any> => {
  const { data } = await api.get("professor/" + id);
  return data;
};

export const professorCadaster = async (body: any): Promise<any> => {
  const { data } = await api.post("professor/cadaster", body);
  return data;
};

export const professorUpdate = async (body: {
  id: string;
  fullName: string;
  email: string;
  phone?: string;
  document?: string;
  birthDate?: Date;
  nickName?: string;
}): Promise<any> => {
  const { data } = await api.put("professor/update", body);
  return data;
};

export const professorDelete = async (body: {
  id: string | number;
}): Promise<any> => {
  const { data } = await api.put("professor/delete", body);
  return data;
};
